import { noop, ErrorSource } from '@datadog/browser-core';
import { StatusType } from '../logger/isAuthorized';
import { createErrorFieldFromRawError } from '../createErrorFieldFromRawError';
export function startRuntimeErrorCollection(configuration, lifeCycle, bufferedDataObservable) {
  if (!configuration.forwardErrorsToLogs) {
    return {
      stop: noop
    };
  }

  var rawErrorSubscription = bufferedDataObservable.subscribe(function (bufferedData) {
    if (bufferedData.type === 0
    /* BufferedDataType.RUNTIME_ERROR */
    ) {
      var error = bufferedData.error;
      lifeCycle.notify(0
      /* LifeCycleEventType.RAW_LOG_COLLECTED */
      , {
        rawLogsEvent: {
          message: error.message,
          date: error.startClocks.timeStamp,
          error: createErrorFieldFromRawError(error),
          origin: ErrorSource.SOURCE,
          status: StatusType.error
        },
        messageContext: error.context
      });
    }
  });
  return {
    stop: function stop() {
      rawErrorSubscription.unsubscribe();
    }
  };
}